import { render, staticRenderFns } from "./SinglePanel.vue?vue&type=template&id=3aa4b9f0&scoped=true"
import script from "./SinglePanel.vue?vue&type=script&lang=js"
export * from "./SinglePanel.vue?vue&type=script&lang=js"
import style0 from "./SinglePanel.vue?vue&type=style&index=0&id=3aa4b9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa4b9f0",
  null
  
)

export default component.exports